export const META_PIXEL_ID = '1734545531213995'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/**
 * Inyecta el código base del Pixel de Meta y dispara el PageView inicial.
 * Seguro de llamar varias veces: solo se instala una vez.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImg = document.createElement('img')
    pixelImg.height = 1
    pixelImg.width = 1
    pixelImg.style.display = 'none'
    pixelImg.alt = ''
    pixelImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImg)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}

/** Clic en el botón principal de compra del Pack Pro-Series. */
export function trackPackAddToCart(
  source: string,
  contentName: string = 'Pack Pro-Series 30 piezas',
  value: number = 399
): void {
  trackPixelEvent('AddToCart', {
    content_name: contentName,
    content_ids: ['pack-pro-series'],
    content_type: 'product',
    value: value,
    currency: 'MXN',
    source,
  })
}

/** Contacto por WhatsApp / interés declarado. */
export function trackLead(source: string): void {
  trackPixelEvent('Lead', {
    content_name: 'Pack Pro-Series 30 piezas',
    value: 399,
    currency: 'MXN',
    source,
  })
}
